import React, { Component, Fragment } from 'react';
import EditableTable from '../../../../../components/EditableTable';
import { GENERIC_SPICE, GENERIC_TOUCHSTONE, PCB_SPICE, PCB_TOUCHSTONE, TOUCHSTONE } from '../../../../../constants/libraryConstants';
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
} from '@ant-design/icons';
import sierraLibrary from '../../../../../services/Sierra/library/libraryStorage';
import Port from '../port';
import '@/publicCss/style.css';
import '@/publicCss/aurora.css';
import './index.css';

const columns = [{
  title: "Component",
  key: "name",
  dataIndex: "name",
  width: 100
},
{
  title: "Pin",
  key: "pin",
  dataIndex: "pin",
  width: "40%"
},
{
  title: "Port",
  key: "port",
  dataIndex: "port"
}]
class ModelTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };

    columns[2].render = (text, record) => {
      const { model } = this.props;
      const isMulti = model.libraries.filter(item => !!item.libraryId).length > 1;
      const pinModel = record.model || {};
      let portText = pinModel.port || "";
      if (isMulti && pinModel.port) {
        portText = pinModel.fileName && pinModel.subckt ? `${pinModel.fileName}::${pinModel.subckt}` : (pinModel.fileName ? pinModel.fileName : "");
        portText = portText ? `${portText}::${pinModel.port}` : pinModel.port;
      }

      return <span title={portText}>{portText}</span>
    }

    columns[1].render = (text, record) => {
      return <span title={record.pinTitle || text}>{record.pinTitle || text}</span>
    }

    columns[2].onCell = (record) => {
      const { keepFocusStatus } = this.state;
      return {
        edit: 'select',
        dataIndex: "port",
        record,
        popupRender: (menu, _record, form, save) => this.getPortRender(menu, _record, form, save),
        handleClear: this.clearPort,
        allowClear: true,
        getPopupContainer: document.getElementById('root'),
        keepFocus: true,
        keepFocusStatus,
        tdClick: () => { this.updateKeepFocusStatus(false) }
      }
    }
  }

  closePortPanel = (form, save) => {
    this.updateKeepFocusStatus(false)
    save && save()
    /*  form && form.resetFields(); */
  }

  updateKeepFocusStatus = (keepFocusStatus) => {
    this.setState({
      keepFocusStatus
    })
  }

  getPortRender = (menu, record, form, save) => {
    const { model: pinModel, pin } = record;
    const { components, libraries, portsObj, fixed, lastOpenModel, model } = this.props;
    const usedPorts = components.map(item => item.pins.map(pin => pin.model || {})).flat(3).filter(item => item.port);

    return <div
      onMouseDown={(e) => {
        e.preventDefault()
        return false
      }}>
      <Port
        pin={{ pin, comp: record.name, pinName: pin, model: { ...(pinModel || {}) } }}
        isTable={true}
        index={`${record.name}::${pin}`}
        libraries={libraries}
        portsObj={portsObj}
        usedPorts={usedPorts}
        modelType={model.modelType}
        lastOpenModel={lastOpenModel}
        saveModel={this.props.saveModel}
        selectOpenModel={this.props.selectOpenModel}
        closePortPanel={() => this.closePortPanel(form, save)}
        fixed={fixed}
        updateKeepFocusStatus={this.updateKeepFocusStatus}
      />
    </div>
  }

  clearPort = (record) => {
    this.props.saveModel({ comp: record.name, pin: record.pin }, { librartId: "", subckt: "", port: "" })
  }

  getComponentData = () => {
    const { components, model, signals } = this.props;
    const isMulti = model.libraries.filter(item => !!item.libraryId).length > 1;
    let data = [];
    let libraryType = PCB_SPICE, genericType = GENERIC_SPICE;
    if (model.modelType === TOUCHSTONE) {
      libraryType = PCB_TOUCHSTONE;
      genericType = GENERIC_TOUCHSTONE;
    }
    const signal = signals.find(it => it.points && it.points.length) || {};
    const sections = signal.sections || [];
    for (let comp of components) {
      if (!comp.pins || !comp.pins.length) {
        continue;
      }
      for (let pin of comp.pins) {
        const libraryFile = isMulti && pin.model && pin.model.libraryId ? sierraLibrary.checkFile(libraryType, pin.model.libraryId) || sierraLibrary.checkFile(genericType, pin.model.libraryId) : null;
        const findSignal = signals.find(it => it.name === pin.signal) || {};
        const findInSection = (findSignal.sections || []).find(it => it.in && it.in.type === "component" && it.in.component === comp.name && it.in.pin === pin.pin);
        const findOutSection = (findSignal.sections || []).find(it => it.out && it.out.type === "component" && it.out.component === comp.name && it.out.pin === pin.pin)

        let pinTitle = "";
        if (findInSection || findOutSection) {
          let inText = "", outText = ""
          if (findInSection && findInSection.out && findInSection.out.type === "point" && findSignal.name !== signal.name) {
            const findS = sections.find(it => it.id === findInSection.id) || {};
            outText = findS.out && findS.out.component ? findS.out.component : findInSection.out.component
          }
          if (findOutSection && findOutSection.in && findOutSection.in.type === "point" && findSignal.name !== signal.name) {
            const findS = sections.find(it => it.id === findOutSection.id) || {};
            inText = findS.in && findS.in.component ? findS.in.component : findOutSection.in.component
          }

          const section = findInSection || findOutSection;
          pinTitle = `${pin.signal}::${inText || (section.in || {}).component} <--> ${outText || (section.out || {}).component}`;
        }
        data.push({
          ...pin,
          name: comp.name,
          pin: pin.pin,
          model: { ...(pin.model || {}), fileName: libraryFile ? libraryFile.name : "" },
          port: pin.model ? pin.model.port : "",
          pinTitle
        })
      }
    }
    return data;
  }

  render() {
    const { showModelTable } = this.props;
    const data = this.getComponentData();
    /*    const content = ( */
    /*  <Panel
       className={`sierra-pre-layout-comp-model-panel sierra-panel`}
       title="Model"
       zIndex={2000}
       width={400}
       minWidth={200}
       minHeight={200}
       position='panel-top-right'
       redirectDom={`pre-layout-schematic-${id}`}
       isRedirectDomId={true}
       onCancel={this.close}
       overflow='hidden'
       draggable
     > */
    return <div className="sierra-pre-layout-comp-model-content" style={{ width: showModelTable ? 430 : 30, height: showModelTable ? null : 30 }}>
      <div className={`schematic-canvas-component-icon ${showModelTable ? "" : "schematic-canvas-component-right-icon"}`} onClick={(e) => this.props.changeModelTableStatus(showModelTable ? false : true)}>
        {showModelTable ? <DoubleRightOutlined title="Close model assignment table" /> : <DoubleLeftOutlined title="Open model assignment table" />}
      </div>
      {showModelTable ?
        <Fragment>
          <EditableTable
            rowKey={(record) => `${record.name}-${record.pin}`}
            columns={columns}
            size="small"
            dataSource={data}
            scroll={{ y: 700 }}
            className="sierra-pre-layout-component-model-table"
          />
        </Fragment>
        : null}
    </div>
    /*       </Panel >) */

    /* return createPortal(content, this.dialogRoot); */
  }
}

export default ModelTable;